// use assert instead of `if(condition) throw` to communicate to code readers that the value
// should indeed be truthy at this point, if it's not, then it's definitely a programming error:
// https://softwareengineering.stackexchange.com/questions/15515/when-to-use-assertions-and-when-to-use-exceptions

export const assertTruthy: (value: unknown, message?: string) => asserts value = (value: unknown, message?: string) => {
    if (!value) {
        throw new Error(message);
    }
};
